import React, { useState, useEffect, useCallback } from 'react';
import { getExpressParams, postExpress } from '../../../service/api';
import { connect } from 'react-redux';

const UpdateTokenModal = ({ tokenItem, onClose, onUpdate }) => {
  // 단일 토큰 대신 두 개의 상태(State)로 나눕니다.
  const [newCookie, setNewCookie] = useState('');
  const [newXsrfToken, setNewXsrfToken] = useState('');

  const handleSubmit = () => {
    // 두 값이 모두 입력되었는지 확인합니다.
    if (newCookie.trim() && newXsrfToken.trim()) {
      onUpdate(tokenItem.userid, newCookie.trim(), newXsrfToken.trim());
      onClose();
    } else {
      alert("Cookie와 XSRF-Token 값을 모두 입력해주세요.");
    }
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <h3>토큰 업데이트 ({tokenItem.userid})</h3>
        <p>Diff: {tokenItem.diff}분 경과</p>
        <hr />

        {/* Cookie 입력란 */}
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>
            Cookie
          </label>
          <input
            type="text"
            value={newCookie}
            onChange={(e) => setNewCookie(e.target.value)}
            placeholder="새로운 Cookie 문자열을 입력하세요"
            style={{ width: '90%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>

        {/* XSRF-Token 입력란 */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>
            XSRF-Token
          </label>
          <input
            type="text"
            value={newXsrfToken}
            onChange={(e) => setNewXsrfToken(e.target.value)}
            placeholder="새로운 XSRF-Token 값을 입력하세요"
            style={{ width: '90%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button onClick={onClose} style={{ padding: '8px 15px', border: '1px solid #ccc', background: '#fff', cursor: 'pointer' }}>
            취소
          </button>
          <button onClick={handleSubmit} style={{ padding: '8px 15px', border: 'none', background: '#6A5ACD', color: '#fff', cursor: 'pointer' }}>
            업데이트 확인
          </button>
        </div>
      </div>
    </div>
  );
};

const TokenManager = (props) => {
  const [tokenList, setTokenList] = useState(null);
  const [modalTokenItem, setModalTokenItem] = useState(null);

  const fetchTokenList = useCallback(() => {
    getExpressParams('/users/token-content/all', {
      email: props.currentUser
    }, (response) => {
      setTokenList(response.data)
    });
  }, [props.currentUser]);

  useEffect(() => {
    fetchTokenList();
  }, [fetchTokenList]);

  // 파라미터로 newCookie와 newXsrfToken 두 개를 받도록 수정
  const handleUpdateToken = (userid, newCookie, newXsrfToken) => {
    console.log(`[Token Update 요청] User ID: ${userid}`);
    console.log(`[Token Update 요청] 새로운 Cookie: ${newCookie.substring(0, 20)}...`);
    console.log(`[Token Update 요청] 새로운 XSRF-Token: ${newXsrfToken.substring(0, 20)}...`);

    // 백엔드로 보낼 때 키 이름도 cookie, xsrfToken으로 맞춰서 보냅니다.
    postExpress('/users/token-content/token', {
      email: props.currentUser,
      userid: userid,
      cookie: newCookie,
      newXsrfToken: newXsrfToken
    }, (response) => {
      console.log(response);
      // 서버 통신이 완료된 이후에 목록을 새로고침 하도록 콜백 내부로 이동
      fetchTokenList();
    });
  };

  return (
    <div>
      <h2>API 세션 데이터 목록</h2>
      {tokenList && tokenList.length > 0 ? (
        <>
          <hr />
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #ccc' }}>
                <th style={tableHeaderStyle}>User ID</th>
                <th style={tableHeaderStyle}>Cookie (일부)</th>
                <th style={tableHeaderStyle}>XSRF-Token (일부)</th>
                <th style={tableHeaderStyle}>수집일</th>
                <th style={tableHeaderStyle}>Diff (분)</th>
                <th style={tableHeaderStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {tokenList.map((tokenItem, index) => (
                <tr key={index} style={index % 2 === 0 ? tableRowEvenStyle : tableRowOddStyle}>
                  <td style={tableCellStyle}>{tokenItem.userid}</td>
                  <td style={tableCellStyle}>
                    {tokenItem.cookie ? `${tokenItem.cookie.substring(0, 20)}...` : 'N/A'}
                  </td>
                  <td style={tableCellStyle}>
                    {tokenItem.token ? `${tokenItem.token.substring(0, 20)}...` : 'N/A'}
                  </td>
                  <td style={tableCellStyle}>{tokenItem.collectDate}</td>
                  <td style={tableCellStyle}>{tokenItem.diff}</td>

                  <td style={tableCellStyle}>
                    <button
                      onClick={() => setModalTokenItem(tokenItem)}
                      style={buttonStyle}
                    >
                      업데이트
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {modalTokenItem && (
            <UpdateTokenModal
              tokenItem={modalTokenItem}
              onClose={() => setModalTokenItem(null)}
              onUpdate={handleUpdateToken}
            />
          )}

        </>
      ) : (
        <div>{tokenList === null ? '데이터를 불러오는 중...' : '등록된 정보가 없습니다.'}</div>
      )}
    </div>
  )
}

const tableHeaderStyle = {
  padding: '10px',
  textAlign: 'left',
  backgroundColor: '#f4f4f4'
};
const tableCellStyle = {
  padding: '10px',
  borderBottom: '1px solid #eee',
  wordBreak: 'break-all' // 긴 텍스트가 테이블 레이아웃을 깨지 않도록 추가
};
const tableRowEvenStyle = {
  backgroundColor: '#f9f9f9'
};
const tableRowOddStyle = {
  backgroundColor: '#ffffff'
};
const buttonStyle = {
  padding: '5px 10px',
  backgroundColor: '#ffc107',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
}
const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
};
const modalContentStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '400px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
};

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
})
export default connect(mapStateToProps)(TokenManager);
/*
import React, { useState, useEffect, useCallback } from 'react';
import { getExpressParams, postExpress } from '../../../service/api';
import { connect } from 'react-redux';

const UpdateTokenModal = ({ tokenItem, onClose, onUpdate }) => {
  const [newToken, setNewToken] = useState('');

  const handleSubmit = () => {
    if (newToken.trim()) {
      onUpdate(tokenItem.userid, newToken.trim());
      onClose();
    } else {
      alert("토큰 문자열을 입력해주세요.");
    }
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <h3>토큰 업데이트 ({tokenItem.userid})</h3>
        <p>Diff: {tokenItem.diff}분 경과</p>
        <hr />

        <input
          type="text"
          value={newToken}
          onChange={(e) => setNewToken(e.target.value)}
          placeholder="새로운 토큰 문자열을 입력하세요"
          style={{ width: '90%', padding: '8px', marginBottom: '15px' }}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button onClick={onClose} style={{ padding: '8px 15px', border: '1px solid #ccc', background: '#fff' }}>
            취소
          </button>
          <button onClick={handleSubmit} style={{ padding: '8px 15px', border: 'none', background: '#6A5ACD', color: '#fff' }}>
            업데이트 확인
          </button>
        </div>
      </div>
    </div>
  );
};

const TokenManager = (props) => {
  const [tokenList, setTokenList] = useState(null);
  const [modalTokenItem, setModalTokenItem] = useState(null);

  // 1. 토큰 목록을 불러오는 함수를 별도로 정의 (useCallback을 사용하여 성능 최적화)
  const fetchTokenList = useCallback(() => {
    // API 호출 로직
    getExpressParams('/users/token-content/all', {
      email: props.currentUser
    }, (response) => {
      setTokenList(response.data)
    });
  }, [props.currentUser]); // props.currentUser가 변경될 때마다 함수 재생성

  // 2. 컴포넌트 마운트 시 토큰 목록 로딩
  useEffect(() => {
    fetchTokenList();
  }, [fetchTokenList]); // fetchTokenList를 의존성 배열에 포함

  // 3. 토큰 업데이트 처리 함수
  const handleUpdateToken = (userid, newToken) => {
    console.log(`[Token Update 요청] User ID: ${userid}`);
    console.log(`[Token Update 요청] 새로운 토큰 문자열: ${newToken}`);

    postExpress('/users/token-content/token', {
      email: props.currentUser,
      userid: userid,
      newToken: newToken
    }, (response) => {
      console.log(response)
    });

    fetchTokenList();

  };


  return (
    <div>
      <h2>API 토큰 목록</h2>
      {tokenList && tokenList.length > 0 ? (
        <>
          <hr />
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #ccc' }}>
                <th style={tableHeaderStyle}>User ID</th>
                <th style={tableHeaderStyle}>Token (일부)</th>
                <th style={tableHeaderStyle}>수집일</th>
                <th style={tableHeaderStyle}>Diff (분)</th>
                <th style={tableHeaderStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {tokenList.map((tokenItem, index) => (
                <tr key={index} style={index % 2 === 0 ? tableRowEvenStyle : tableRowOddStyle}>
                  <td style={tableCellStyle}>{tokenItem.userid}</td>
                  <td style={tableCellStyle}>{tokenItem.token ? `${tokenItem.token.substring(0, 30)}...` : 'N/A'}</td>
                  <td style={tableCellStyle}>{tokenItem.collectDate}</td>
                  <td style={tableCellStyle}>{tokenItem.diff}</td>

                  <td style={tableCellStyle}>
                    <button
                      onClick={() => setModalTokenItem(tokenItem)}
                      style={buttonStyle}
                    >
                      업데이트
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {modalTokenItem && (
            <UpdateTokenModal
              tokenItem={modalTokenItem}
              onClose={() => setModalTokenItem(null)}
              onUpdate={handleUpdateToken}
            />
          )}

        </>
      ) : (
        <div>{tokenList === null ? '토큰 목록을 불러오는 중...' : '등록된 토큰 정보가 없습니다.'}</div>
      )}
    </div>
  )
}

const tableHeaderStyle = {
  padding: '10px',
  textAlign: 'left',
  backgroundColor: '#f4f4f4'
};
const tableCellStyle = {
  padding: '10px',
  borderBottom: '1px solid #eee'
};
const tableRowEvenStyle = {
  backgroundColor: '#f9f9f9'
};
const tableRowOddStyle = {
  backgroundColor: '#ffffff'
};
const buttonStyle = {
  padding: '5px 10px',
  backgroundColor: '#ffc107',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
}
const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
};
const modalContentStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '400px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
};

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
})
export default connect(mapStateToProps)(TokenManager);
*/